import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import debounce from 'lodash.debounce';
import Button from 'ac-components/ac-btn';
import Input from 'ac-components/ac-ipt';
import Alert from 'ac-components/alert';
import AreaSelect, { Area } from '../area-select';
import { Mode, View } from './interface';
import * as Request from '@services/login';
import * as Trace from './trace';
import styles from './styles.scss';
import { Token } from 'states/interface';
import { emailReg } from 'constants/regXpRules';
import { SendSmsBtn } from 'containers/ac-containers/reset-password';
import { useTranslation } from 'hooks/use-translation';
import AcIcon from 'ac-components/ac-icon';
import { _checkAccount } from './signup'
import { emailCodeSent, loginWithPsw, resetPassword } from '@services/login';
const PWD_TIP = {
	least: 'Password should be of at least 8 characters',
	most: 'Password should be of at most 20 characters',
	match: 'Password do not match'
}

type LoginMode = 'Phone' | 'Email'
type ChangeView = (view: View, token?: Token) => void;
interface LoginProps {
	className?: string;
	changeView(view: View, token?: Token): void;
}
interface PhoneModeProps {
	className?: string;
	changeView: ChangeView;
	showInfoChange(flag: string): void;
}
interface EmailModeProps {
	className?: string;
	changeView: ChangeView;
	loginModeVisibleChange(): void;
}

export function _checkEmpty(v: string, setTipCb: (s: string) => void): boolean {
	const isEmpty = v === ''
	typeof setTipCb === 'function' && setTipCb(isEmpty ? 'Required' : '')
	return isEmpty
}
export function _checkValidEmail(v: string, setTipCb?: (s: string) => void, err?: string): boolean {
	const isValid = v !== '' && emailReg.test(v)
	typeof setTipCb === 'function' && setTipCb(isValid ? '' : err || 'You must enter a valid email address')
	return isValid
}

export function useCodeSentCountdown(defaultCount: number) {
	const [timerCount, setTimerCount] = useState(0)
	const timerCountRef = useRef<number>(0)
	const countdownTimer = useRef<number>(0)

	const countdownHandler = () => {
		timerCountRef.current = defaultCount
		setTimerCount(timerCountRef.current)
		countdownTimer.current = window.setInterval(() => {
			timerCountRef.current -= 1
			setTimerCount(timerCountRef.current)
			if (timerCountRef.current === 0) clearInterval(countdownTimer.current)
		}, 1000)
	}

	useEffect(() => {
		return () => clearInterval(countdownTimer.current);
	}, [])

	return { timerCount, timerCountRef, countdownHandler }
}

export function CardWrap(props: { className?: string; children?: React.ReactNode }) {
	const { children } = props
	return (
		<div className={classNames(styles.login, styles.card, props.className)}>
			{children}
		</div>
	)
}
export function CardTitle(props: { title: string }) {
	return <h1 className={styles.title}>{props.title}</h1>
}
interface AlterTipProps {
	alertTip?: string;
	type?: 'error' | 'success' | 'warn' | '';
	duration?: number;
	onClose?: () => void;
	className?: string;
}
export function AlertTip(props: AlterTipProps) {
	const { alertTip, type, duration = 5, onClose, className = '' } = props

	const closeHandler = () => {
		typeof onClose === 'function' && onClose()
	}

	return <div className={`${styles.alert_wrap} ${className}`}>
		{alertTip && <Alert type={type ? type : 'error'} duration={duration} onClose={closeHandler}>{alertTip}</Alert>}
	</div>
}
export function CardFormItem(props: { label: string; verifyTip?: string; labelTip?: string; children: React.ReactNode }) {
	const { label, verifyTip = '', labelTip = '', children } = props
	return (
		<div className={styles.item}>
			<div className={styles.label}>
				{label}
				{ labelTip && (
					<span className={styles.label_tip}>
					<AcIcon icon=' icon_info' />
					<div>{labelTip}</div>
				</span>
				)  }
			</div>
			<div className={styles.verify_tip}>{verifyTip}</div>
			{children}
		</div>
	)
}
function PwdEyeSuffix(props: { type: boolean; typeChange(): void }) {
	const { type, typeChange } = props
	const [isPwd, setIsPwd] = useState(true)

	useEffect(() => {
		setIsPwd(type)
	}, [type])

	const handlePwdTypeChange = () => {
		setIsPwd(!isPwd)
		typeChange()
	}

	return (
		<i onClick={handlePwdTypeChange} className={`${styles.watch_icon} iconfont ${!isPwd ? 'icon_eyeopened' : 'icon_eyeclosed'}`} />
	)
}

function PhoneMode(props: PhoneModeProps) {
	const { className, changeView, showInfoChange } = props;
	const [mode, setMode] = useState<Mode>(Mode.psw);
	const [area, setArea] = useState<Area>();
	const [areaTip, setAreaTip] = useState<string>('');
	const [phone, setPhone] = useState<string>('');
	const [phoneTip, setPhoneTip] = useState<string>('');
	const [psw, setPsw] = useState<string>('');
	const [pswTip, setPswTip] = useState<string>('');
	const [sms, setSms] = useState<string>('');
	const [smsTip, setSmsTip] = useState<string>('');
	const [next, setNext] = useState<boolean>(false);
	const [alertTip, setAlertTip] = useState<string>('');
	const loadingRef = useRef<boolean>(false); // 是否登录中
	const [count, setCount] = useState<number>(0);
	const cardRef = useRef<HTMLDivElement | null>(null);
	const countDownRef = useRef<number>(0);
	const { transData } = useTranslation('login')

	const timerRef = useRef<number>();

	const startCountDown = () => {
		countDownRef.current = 120;
		setCount(countDownRef.current);
		timerRef.current = window.setInterval(() => {
			countDownRef.current--;
			setCount(countDownRef.current);
			if (countDownRef.current === 0) {
				clearInterval(timerRef.current);
			}
		}, 1000);
	}

	useEffect(() => {
		return () => clearInterval(timerRef.current);
	}, [])

	const onModeChange = () => {
		if (mode === Mode.psw) {
			Trace.loginModeChange();
		}
		setAlertTip('');
		setMode(mode === Mode.psw ? Mode.sms : Mode.psw);
		loadingRef.current = false;
	}
	// 选择国家地区
	const onAreaChange = (item: Area) => {
		if(item && item.code === '86') {
			showInfoChange('1');
		} else {
			showInfoChange('0');
		}
		setArea(item);
		setAreaTip('');
		setAlertTip('');
	}
	// 输入号码
	const onPhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setPhone(e.target.value);
		setPhoneTip('');
		setAlertTip('');
	}
	// 输入密码
	const onPswChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setPsw(e.target.value.trim());
		setPswTip('');
		setAlertTip('');
	}

	// 密码登录
	const loginWithPsw = async () => {
		if (!area) return
		if (loadingRef.current) return // 登录中
		loadingRef.current = true;
		const res = await Request.loginWithPsw({
			areaCode: area.code,
			mobile: phone,
			password: psw,
		})
		loadingRef.current = false;
		if (res.code === Request.ResponseCode.OK) {
			changeView(View.fill, res.data);
		} else {
			setAlertTip(res.message || transData.failed);
		}
	}

	function _checkPsw(psw: string, setPswTip: (v: string) => void): boolean {
		let _flag = true
		if (psw === '') {
			setPswTip(transData.required);
			_flag = false;
		} else if (psw.length < 8) {
			setPswTip(transData.pwsText);
			_flag = false;
		} else if (psw.length > 20) {
			setPswTip(transData.pwsText1);
			_flag = false;
		}
		return _flag
	}

	// 点击密码登录
	const onPswLoginHandle = () => {
		Trace.login();
		let fire = true;
		// if (!area) {
		// 	setAreaTip('未选择地区');
		// 	return
		// }
		if (!phone) {
			setPhoneTip(transData.required);
			fire = false;
		}
		fire = _checkPsw(psw, setPswTip)
		if (!fire) return;
		loginWithPsw();
	}


	// 验证码登录
	const loginWithSms = useRef(debounce(async (sms: string, phone: string, area?: Area) => {
		if (!sms) return
		if (!area) return
		if (loadingRef.current) return; // 登录中
		loadingRef.current = true;
		const res = await Request.loginWithSms({
			areaCode: area.code,
			mobile: phone,
			validateCode: sms,
		});
		loadingRef.current = false;
		if (res.code === Request.ResponseCode.OK) {
			changeView(View.fill, res.data); // 登录成功
		} else {
			setAlertTip(res.message); // 登录失败
		}
	}, 1000));

	// 输入验证码
	const onSmsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setAlertTip('');
		const value = e.target.value;
		setSms(value);
		loginWithSms.current(value.trim(), phone, area);
	}

	// 发送验证码
	const sendSms = async () => {
		if (loadingRef.current) return
		if (count !== 0) return false;
		if (!area) return false;
		loadingRef.current = true;
		const data = await Request.geetestApi1({
			mobile: phone,
		});
    console.log(data,'data');
		// console.log(!(data as any).success,'asdfadsfaf');

		(window as any).initGeetest(
			{
				gt: (data as any).gt,
				challenge: (data as any).challenge,
				offline: !(data as any).success, // 表示用户后台检测极验服务器是否宕机
				new_captcha: (data as any).new_captcha, // 用于宕机时表示是新验证码的宕机
				product: "bind", // 产品形式，包括：float，popup
				width: "300px",
				https: true,
				lang:'en'
			},
			(captchaObj: any) => {
				captchaObj
					.onReady(() => {
						captchaObj.verify(); // 显示验证码
					})
					.onSuccess(async () => {
						// your code
						const result = captchaObj.getValidate();
						console.log(result,'resultresultresult');
						const vo = {
							challenge: result.geetest_challenge,
							seccode: result.geetest_seccode,
							validate: result.geetest_validate,
							status:1
						}
						const send = await Request.getLoginSmsCode({ areaCode: area.code, mobile: phone, vo });
						console.log(send,'send');
						loadingRef.current = false;
						if (send.code === Request.ResponseCode.OK && send.data) {
							startCountDown();
							setNext(true);
						} else {
							setAlertTip(send.message);
							setNext(false);
						}
					})
					.onError(() => {
						// your code
						console.log("失败");
					});
			}
		);
	}

	// 验证码点击下一步
	const onSmsNextHandle = async () => {
		if (phoneTip) return
		if (!phone) {
			setPhoneTip(transData.required);
			return
		}
		const send = await sendSms();
		if (send) { // 发送成功
			setAlertTip('');
			setNext(true);
		}
		// setNext(true);
	}

	const prevHandle = () => {
		loadingRef.current = false;
		setNext(false);
		clearInterval(timerRef.current);
		setCount(0)
	}

	if (next) {
		return (
			<div className={classNames(styles.login, styles.card, className)} ref={cardRef}>
				<h1 className={styles.title}>
					<span className={styles.back} onClick={prevHandle}>
						<AcIcon icon='icon_back' />
					</span>
					{transData.title}
				</h1>
				<div className={styles.phone_info}>
					<span>{transData.codeText1}</span>
					<span>{transData.codeText2}</span>
					<span>+{area?.code} {phone}</span>
				</div>
				<div className={styles.alert_wrap}>
					{alertTip && <Alert type='error'>{alertTip}</Alert>}
				</div>
				<CardFormItem label={transData.code} verifyTip={smsTip}>
					<Input
						onChange={onSmsChange}
						type='number'
						placeholder={transData.code}
						value={sms}
					/>
				</CardFormItem>
				<Button disabled={count !== 0} onClick={sendSms}>
					{count === 0 ? transData.sendText : `${transData.sendText1} ${count}${transData.second}`}
				</Button>
				{/*<div className={styles.footer}>*/}
				{/*	Don&apos;t have an AirClass account?*/}
				{/*	<div className={styles.signup_btn} onClick={createAccount}>Create an account</div>*/}
				{/*</div>*/}
			</div>
		)
	}

	return (
		<div className={classNames(styles.login, styles.card, className)} ref={cardRef}>
			<h1 className={styles.title}>
				{transData.title}
			</h1>
			<div className={styles.alert_wrap}>
				{alertTip && <Alert type='error'>{alertTip}</Alert>}
			</div>
			<div className={styles.item}>
				<div className={styles.label}>{transData.phone}</div>
				<div className={styles.verify_tip}>{areaTip || phoneTip}</div>
				<Input
					className={styles.phone}
					type='number'
					placeholder={transData.phone}
					onChange={onPhoneChange}
					value={phone}
					prefix={(
						<AreaSelect
							selected={area}
							onChange={onAreaChange}
							width={cardRef.current?.offsetWidth}
						/>
					)}
				/>
			</div>
			{
				mode === Mode.psw ? (
					<>
						<CardFormItem label={transData.psw} verifyTip={pswTip}>
							<Input
								type='password'
								placeholder={transData.psw}
								onChange={onPswChange}
								value={psw}
							/>
						</CardFormItem>
						<span
							className={styles.mode_btn}
							onClick={onModeChange}
						>
							{transData.text2}
						</span>
						<Button disabled={!!(areaTip && phoneTip && pswTip)} onClick={onPswLoginHandle}>{transData.login}</Button>
					</>
				) : (
					<>
						<span
							className={styles.mode_btn}
							onClick={onModeChange}
						>
							{transData.text1}
						</span>
						<Button disabled={!!(areaTip && phoneTip)} onClick={onSmsNextHandle}>{transData.codeText}</Button>
					</>
				)
			}
			{/*<div className={styles.footer}>*/}
			{/*	Don&apos;t have an AirClass account?*/}
			{/*	<div className={styles.signup_btn} onClick={createAccount}>Create an account</div>*/}
			{/*</div>*/}
		</div >
	)
}
function EmailMode(props: EmailModeProps) {
	const { loginModeVisibleChange, changeView } = props
	const [forgetPswVision, setForgetPswVision] = useState(false)

	const handleModeChange = () => {
		setForgetPswVision(!forgetPswVision)
		loginModeVisibleChange()
	}

	return (
		<div className={classNames(styles.login, styles.card)}>
			{forgetPswVision ? <ForgetPsw backToLogin={handleModeChange} /> : <EmailLogin forgetPsw={handleModeChange} changeView={changeView} />}
		</div>
	)
}

function EmailLogin(props: { forgetPsw(): void; changeView: ChangeView }) {
	const { forgetPsw, changeView } = props
	const [alertTip, setAlertTip] = useState('')
	const [emailTip, setEmailTip] = useState('')
	const [email, setEmail] = useState('')
	const [pswTip, setPswTip] = useState('')
	const [psw, setPsw] = useState('')
	const [loginLoading, setLoginLoading] = useState(false)
	const { transData, t } = useTranslation('login')

	const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setEmail(e.target.value.trim())
		setEmailTip('')
		setAlertTip('')
	}

	const handlePswChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setPsw(e.target.value.trim())
		setPswTip('')
		setAlertTip('')
	}

	const handleForgetClick = () => {
		forgetPsw()
	}

	const handleLoginClick = async () => {
		Trace.emailLogin()
		let emailCheckRes = _checkEmpty(email, setEmailTip)
		let pswCheckRes = _checkEmpty(psw, setPswTip)
		if (emailCheckRes || pswCheckRes) return
		emailCheckRes = _checkValidEmail(email, setEmailTip, transData.emailErr)
		if (psw.length < 8) setPswTip(PWD_TIP['least'])
		if (psw.length > 20) setPswTip(PWD_TIP['most'])
		pswCheckRes = !(psw.length < 8 || psw.length > 20)
		if (!emailCheckRes || !pswCheckRes) return
		try {
			setLoginLoading(true)
			const loginRes = await loginWithPsw({ email, password: psw })
			if (loginRes?.data) {
				changeView(View.fill, loginRes.data);
			} else {
				setAlertTip(loginRes.message || transData.failed);
				setLoginLoading(false)
			}
		} catch (e) {
			setLoginLoading(false)
		}
	}

	return (
		<>
			<CardTitle title={transData.title} />
			<AlertTip alertTip={alertTip} />
			<CardFormItem label={t('profile.email')} verifyTip={emailTip}>
				<Input
					placeholder={t('profile.email')}
					onChange={handleEmailChange}
					value={email}
				/>
			</CardFormItem>
			<CardFormItem label={t('profile.password')} verifyTip={pswTip}>
				<Input
					type='password'
					placeholder={t('profile.password')}
					onChange={handlePswChange}
					value={psw}
				/>
			</CardFormItem>
			<span className={styles.mode_btn} onClick={handleForgetClick}>{transData.forgot_psw}</span>
			<Button disabled={!!(emailTip && pswTip)} loading={loginLoading} onClick={handleLoginClick}>{transData.login}</Button>
		</>
	)
}
// 邮箱登录模式下的，忘记密码
let _successEmail = ''
let _successValidateCode = ''
function ForgetPsw(props: { backToLogin(): void }) {
	const { backToLogin } = props
	const [step, setStep] = useState<number>(1)

	const stepChange = (v?: number) => {
		if (v) {
			setStep(v)
			return
		}
		if (step > 3) return
		setStep(step + 1)
	}

	return (
		<>
			{step === 1 && <StepOne stepChange={stepChange} backToLogin={backToLogin} />}
			{step === 2 && <StepTwo stepChange={stepChange} />}
			{step === 3 && <StepThree stepChange={stepChange} />}
			{step === 4 && <StepFour />}
		</>
	)
}
// 邮箱输入
function StepOne(props: { stepChange(): void; backToLogin(): void }) {
	const { stepChange, backToLogin } = props
	const [alertTip, setAlertTip] = useState('')
	const [emailTip, setEmailTip] = useState('')
	const [email, setEmail] = useState('')
	const [checkAccountLoading, setCheckAccountLoading] = useState(false)
	const { transData, t } = useTranslation('login')
	const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setEmail(e.target.value.trim())
		setEmailTip('')
	}
	const handleEmailBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
		_checkValidEmail(e.target.value.trim(), setEmailTip, transData.emailErr)
	}
	const handleNextClick = async () => {
		Trace.emailForgotPwdStep1()
		if (_checkEmpty(email, setEmailTip)) return
		try {
			setCheckAccountLoading(true)
			const checkRes = await _checkAccount({ email, scene: 3 })
			if (checkRes?.data === false) {
				setEmailTip(transData.unregistered)
				return
			}
			_successEmail = email
		} finally {
			setCheckAccountLoading(false)
		}
		stepChange()
	}

	const handleRememberLoginClick = () => {
		backToLogin()
	}

	return (
		<CardWrap>
			<CardTitle title={t('profile.resetPwd')} />
			<AlertTip alertTip={alertTip} />
			<CardFormItem label='Email' verifyTip={emailTip}>
				<Input
					placeholder='Email'
					onChange={handleEmailChange}
					onBlur={handleEmailBlur}
					value={email}
				/>
			</CardFormItem>
			<Button
				disabled={!!emailTip}
				loading={checkAccountLoading}
				className={styles.email_next_step}
				onClick={handleNextClick}>
				Next Step
			</Button>
			<p className={styles.email_remember}>
				I remember now,
				<span className={styles.remember_btn} onClick={handleRememberLoginClick}>Login</span>
			</p>
		</CardWrap>
	)
}
// 验证码输入
function StepTwo(props: { stepChange(): void }) {
	const { stepChange } = props
	const [alertTip, setAlertTip] = useState('')
	const [code, setCode] = useState('')
	const [codeTip, setCodeTip] = useState('')
	const [codeSentLoading, setCodeSentLoading] = useState(false)
	const { timerCount, timerCountRef, countdownHandler } = useCodeSentCountdown(120)
	const { transData } = useTranslation('login')

	const getCode = async (cdFlag = true) => {
		try {
			setCodeSentLoading(true)
			const sentRes = await emailCodeSent({ email: _successEmail, scene: 3 })
			if (sentRes?.data === true && cdFlag) countdownHandler()
		} finally {
			setCodeSentLoading(false)
		}
	}

	const handleCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const _value = e.target.value.trim()
		setCode(_value)
		setCodeTip('')
	}
	const handleCodeSentClick = async () => {
		if (timerCount || codeSentLoading) return
		getCode()
	}
	const handleCodeConfirmClick = () => {
		Trace.emailForgotPwdStep2()
		if (_checkEmpty(code, setCodeTip)) return
		_successValidateCode = code
		stepChange()
	}

	useEffect(() => {
		if (!codeSentLoading) {
			countdownHandler() // 从上一步进入的，防止接口较慢，先开始倒计时
			getCode(false)
		}
	}, [])

	return (
		<CardWrap>
			<CardTitle title='Reset Password' />
			<p className={styles.email_code_sent_tip}>
				{ transData.sentEmailBefore }<br />
				{`${_successEmail}`}{ transData.sentEmailBefore }
			</p>
			<AlertTip alertTip={alertTip} />
			<CardFormItem label='Code' verifyTip={codeTip}>
				<Input
					type='number'
					placeholder='Code'
					onChange={handleCodeChange}
					value={code}
					suffix={<SendSmsBtn onClick={handleCodeSentClick} count={timerCount} />}
				/>
			</CardFormItem>
			<Button disabled={!!codeTip} onClick={handleCodeConfirmClick}>Confirm</Button>
		</CardWrap>
	)
}
// 新密码输入
function StepThree(props: { stepChange(v?: number): void }) {
	const { stepChange } = props
	const [alertTip, setAlertTip] = useState('')
	const [psw1Tip, setPsw1Tip] = useState('')
	const [psw1, setPsw1] = useState('')
	const [psw2Tip, setPsw2Tip] = useState('')
	const [psw2, setPsw2] = useState('')
	const [isPwd, setIsPwd] = useState(true)
	const { transData, t } = useTranslation()
	const [resetLoading, setResetLoading] = useState(false)
	const handlePsw1Change = (e: React.ChangeEvent<HTMLInputElement>) => {
		setPsw1(e.target.value.trim())
		setPsw1Tip('')
		setAlertTip('')
	}
	const handlePsw2Change = (e: React.ChangeEvent<HTMLInputElement>) => {
		setPsw2(e.target.value.trim())
		setPsw2Tip('')
		setAlertTip('')
	}
	const handlePwdTypeChange = () => {
		setIsPwd(!isPwd)
	}
	const handleResetPswLinkClick = () => {
		stepChange(1)
		setPsw1Tip('')
		setPsw2Tip('')
		setPsw1('')
		setPsw2('')
	}
	const handleUpdatePwdClick = async () => {
		Trace.emailForgotPwdStep3()
		const psw1EmptyRes = _checkEmpty(psw1, setPsw1Tip)
		const psw2EmptyRes = _checkEmpty(psw2, setPsw2Tip)
		if (psw1EmptyRes || psw2EmptyRes) return
		const psw1CheckRes = psw1.length >= 8 && psw1.length <= 20
		const psw2CheckRes = psw2.length >= 8 && psw2.length <= 20
		if (psw1.length < 8) setPsw1Tip(PWD_TIP['least'])
		if (psw1.length > 20) setPsw1Tip(PWD_TIP['most'])
		if (psw2.length < 8) setPsw2Tip(PWD_TIP['least'])
		if (psw2.length > 20) setPsw2Tip(PWD_TIP['most'])
		if (!psw1CheckRes || !psw2CheckRes) return
		if (psw1 !== psw2) {
			setPsw2Tip(PWD_TIP['match'])
			return;
		}
		try {
			setResetLoading(true)
			const resetRes = await resetPassword({ email: _successEmail, validateCode: _successValidateCode, password: psw1 })
			if (resetRes?.data === true) {
				stepChange()
				_successEmail = ''
				_successValidateCode = ''
			} else {
				setResetLoading(false)
				setAlertTip(resetRes?.message)
			}
		} catch (e) {
			setResetLoading(false)
		}
	}

	return (
		<CardWrap>
			<CardTitle title={t('profile.resetPwd')} />
			<AlertTip alertTip={alertTip} />
			<CardFormItem label='New Password' verifyTip={psw1Tip} labelTip={t('login.pwsText')}>
				<Input
					type={isPwd ? 'password' : 'text'}
					placeholder={t('profile.password')}
					onChange={handlePsw1Change}
					value={psw1}
					suffix={<PwdEyeSuffix type={isPwd} typeChange={handlePwdTypeChange} />}
				/>
			</CardFormItem>
			<CardFormItem label='Re-enter the New Password' verifyTip={psw2Tip}>
				<Input
					type={isPwd ? 'password' : 'text'}
					placeholder={t('profile.password')}
					onChange={handlePsw2Change}
					value={psw2}
					suffix={<PwdEyeSuffix type={isPwd} typeChange={handlePwdTypeChange} />}
				/>
			</CardFormItem>
			<Button disabled={!!(psw1Tip && psw2Tip)} loading={resetLoading} onClick={handleUpdatePwdClick}>Update Password</Button>
			<p onClick={handleResetPswLinkClick} className={styles.psw_reset_link}>Request a new reset password link</p>
		</CardWrap>
	)
}
// 重置成功
function StepFour() {

	const handleOKClick = () => {
		Trace.emailForgotPwdStep4()
		window.location.reload()
	}

	return (
		<CardWrap>
			<CardTitle title='Reset Password' />
			<AlertTip />
			<div className={styles.update_success}>
				<div className={styles.success_img_wrap}>
					<img src='https://web-data.zmlearn.com/image/tBUiQdZPbd6fxbCHzXQwar/login_forget_success.png' alt='update success' />
				</div>
				<p>New password updated successfully!<br />Please sign in again.</p>
				<Button onClick={handleOKClick}>OK</Button>
			</div>
		</CardWrap>
	)
}

export default function Login(props: LoginProps) {
	const { changeView } = props;
	const [loginMode, setLoginMode] = useState<LoginMode>('Phone')
	const [loginModeChangeVision, setLoginModeChangeVision] = useState<boolean>(true)
	const { transData, t } = useTranslation('login')
	const [ifShowFlag, setIfShowFlag] = useState<string>('1'); // 是否展示政策信息
	const handleLoginModeChange = () => {
		setLoginMode(loginMode === 'Phone' ? 'Email' : 'Phone')
		loginMode === 'Phone' && Trace.changeToEmailLogin()
	}

	const createAccount = () => {
		Trace.createAccount();
		changeView(View.signup);
	}

	const handleLoginModeVisibleChange = () => {
		setLoginModeChangeVision(!loginModeChangeVision)
	}

	const handleShowInfoChange = (v: string) => {
		setIfShowFlag(v);
	}

	return (
		<div className={styles.card_wrap}>
			{loginMode === 'Phone' && <PhoneMode {...props} showInfoChange={handleShowInfoChange} />}
			{loginMode === 'Email' && <EmailMode {...props} loginModeVisibleChange={handleLoginModeVisibleChange} />}
			{loginModeChangeVision &&
				<>
					<div className={styles.mode_switch_wrap}>
						{loginMode === 'Phone' &&
							<>
								{ifShowFlag === '1' && (
									<div className={styles.show_info}>
										<p>1.受中国政策影响，呼叫代码为+86的电话号码不能注册；</p>
										<p>2.您也可以继续使用邮箱登录。</p>
									</div>
								)}
							</>
						}
						<div className={styles.divide_line}>
							<span>OR</span>
						</div>
						<Button className={styles.switch_btn} type='primary' onClick={handleLoginModeChange}>
							<i className={classNames('iconfont', loginMode === 'Phone' ? 'icon_mail1' : 'icon_phone', styles.login_iconfont)} />
							{t('login.switch_mode', { mode: loginMode === 'Phone' ? t('profile.email') : t('profile.phone') })}
						</Button>
					</div>

					<div className={styles.login_footer}>
						{transData.text}
						<div className={styles.signup_btn} onClick={createAccount}>{transData.createText}</div>
					</div>
				</>
			}
		</div>
	)
}
